<template>
	<div class="full-projects-menu-container display-flex flex-column flex-align-start height-100" :class="{ 'is-open': isOpen }">
		<template v-if="isOpen">
			<PinProjectMenuButton class="pin-button-container" />
			<h3 class="mb-6">Create and manage</h3>
			<ProjectMenu fullPage />
		</template>
	</div>
</template>

<script>
import ProjectMenu from '@/components/ProjectMenu/ProjectMenu.vue';
import PinProjectMenuButton from '@/components/ProjectMenu/PinProjectMenuButton.vue';
export default {
	name: 'FullProjectMenu',
	components: {
		ProjectMenu,
		PinProjectMenuButton,
	},
	props: {
		isOpen: { type: Boolean },
	},
	computed: {},
	methods: {},
};
</script>

<style scoped lang="scss">
.full-projects-menu-container {
	min-width: 0px;
	max-width: 0px;
	transition: 0.3s;
	&.is-open {
		transition: 0.3s;
		background: var(--white);
		padding: 28px 14px 14px 14px;
		width: $projects-full-menu-width;
		border-right: 1px solid #dfdfe2;
		min-width: $projects-full-menu-width;
		max-width: $projects-full-menu-width;
	}
}

.pin-button-container {
	top: 14px;
	position: absolute;
	left: calc(#{$projects-full-menu-width} - (#{$pin-projects-button-size} / 2));
}
</style>
